<template>
  <div class="product-detail-header">
    <div class="product-detail-header-info">
      <ym-img class="product-detail-header-info-left"
              :src="course.cover"
      />
      <div class="product-detail-header-info-right">
        <div class="product-detail-header-info-right-top ym-two-line-ellipsis">
          {{ course.title }}
        </div>
        <div class="product-detail-header-info-right-bottom">
          <span v-html="liveTime"></span>
        </div>
      </div>
    </div>
    <div v-if="renderPrice.discount"
         class="product-detail-header-action-left-price-discount"
    >
      {{ renderPrice.discount.name }}
    </div>
    <div class="product-detail-header-action">
      <div class="product-detail-header-action-left">
        <div class="product-detail-header-action-left-price">
          <div v-if="course.id === 559"></div>
          <span v-else>
            {{ renderPrice.discount ? renderPrice.discount.price : renderPrice.originPrice }}
          </span>
          <span v-if="renderPrice.discount"
                class="origin-price"
          >{{ renderPrice.originPrice }}</span>
        </div>
      </div>
      <div v-if="collect.show"
           class="product-detail-header-action-right"
           :class="{ 'collected': collected }"
           @click="handleClickCollect"
           v-ym-report:COURSE_DETAIL_COLLECTION_CLICK="{ id: course.id }"
      >
        <ym-icon :name="statusMap"
                 :color="collected ? '#02cccc' : '#999'"
                 size="15"
        />
        <span>{{ textMap }}</span>
      </div>
    </div>
    <vip-benefit-bar :save-more="saveMore"
                     :tab-selected="tabSelected"
    />
  </div>
</template>

<script>
  import validator from '@/utils/validator';
  import { toggleMyCollect } from '@/services/user';
  import VipBenefitBar from '@/components/ProductDetail/VipBenefitBar';

  export default {
    name: 'ProductDetailHeader',
    components: {
      VipBenefitBar,
    },
    props: {
      course: {
        validator(val) {
          return validator.isObject(val);
        },
      },
      renderPrice: {
        validator(val) {
          return validator.isObject(val);
        },
      },
      collect: {
        validator(val) {
          return validator.isObject(val);
        },
      },
      saveMore: Object,
      tabSelected: String,
    },
    data() {
      return {
        disabled: false,
        collected: false,
      };
    },
    computed: {
      statusMap() {
        return this.collected ? 'yishoucang' : 'shoucang';
      },
      textMap() {
        return this.collected ? '已收藏' : '收藏';
      },
      liveTime() {
        return this.course.liveTime.replace(/\n/g, '<br>');
      },
    },
    methods: {
      async handleClickCollect() {
        const { disabled, collected } = this;
        if (disabled) return;
        this.disabled = true;
        const collectAction = Number(!collected);
        try {
          await toggleMyCollect('course', this.course.id, collectAction);
          this.collected = !this.collected;
          this.disabled = false;
        } catch (e) {
          this.disabled = false;
        }
      },
    },
    created() {
      this.collected = this.collect.isCollected;
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .product-detail-header {
    padding: 40px;
    box-sizing: border-box;
    border-bottom: 11px solid #f4f4f4;
    &-info {
      display: flex;
      margin-bottom: 40px;
      &-left {
        width: 180px;
        height: 180px;
        margin-right: 30px;
        border-radius: 8px;
        overflow: hidden;
      }
      &-right {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        &-top {
          color: @color-black-dark;
          font-size: @font-size-medium;
          font-weight: @font-weight-bold;
          line-height: 45px;
        }
        &-bottom {
          display: flex;
          flex-direction: column;
          color: @color-text-lighter;
          font-size: 26px;
          line-height: 36px;
        }
      }
    }
    &-action {
      display: flex;
      align-items: center;
      justify-content: space-between;
      &-left {
        display: flex;
        flex-direction: column;
        justify-content: center;
        &-price {
          display: flex;
          align-items: flex-end;
          span {
            line-height: 1;
            &:first-child {
              color: #ff0f0f;
              font-size: @font-size-extra-extra-large;
              font-weight: @font-weight-bold;
              &:before {
                content: '¥';
                font-size: @font-size-base;
              }
            }
            &.origin-price {
              position: relative;
              top: -2px;
              color: @color-text-lighter;
              font-size: @font-size-base;
              margin-left: 14px;
              text-decoration: line-through;
              &:before {
                content: '¥';
              }
            }
          }
          &-discount {
            color: #ff0f0f;
            font-size: @font-size-base;
            line-height: 1;
          }
        }
      }
      &-right {
        height: 60px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 24px;
        box-sizing: border-box;
        border-radius: 15px;
        background-color: #f5f6f7;
        color: #999;
        font-size: 26px;
        &.collected {
          background-color: #e9f7f7;
          color: #13b9bf;
        }
        span:last-child {
          margin-left: 8px;
        }
      }
    }
  }
</style>
